import {Box, MenuItem, Typography} from "@mui/material"
import LabeledSelect               from "../LabeledSelect"
import {useEffect, useState}       from "react"
import {fetchLLMModels}            from "../../util/admin"

const SelectLlmModel = ({llmModel, onChangeLlmModel, sx}) => {

	const [llmModels, setLlmModels] = useState([])

	useEffect(()=>{
		const fn = async () => {
			const llms = await fetchLLMModels()
			setLlmModels(llms)
		}
		fn()
	}, [])


	const getLlmModelByName = (llmModelName) => {
		return llmModels.find(m=>m.name===llmModelName)
	}

	// Handle empty or undefined category
	const selectedLlmModel = getLlmModelByName(llmModel)

	return <LabeledSelect
		sx={sx}
		value={selectedLlmModel ? selectedLlmModel.name : ''}
		onChange={e => onChangeLlmModel(getLlmModelByName(e.target.value))}
		displayEmpty
		fullWidth
		label="LLM Model"
		placeholder={llmModels ? `Select LLM Model` : `Loading LLM Models...`}
	>
		<MenuItem value={0}>
			<Typography component="span" style={{opacity: 0.5}}>
				Select LLM Model
			</Typography>
		</MenuItem>
		{
			llmModels && llmModels.map((m,i) => {
				return <MenuItem key={m.name} value={m.name}>
					<Box display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center">
						<Typography component="span">
							{m.name}
						</Typography>
					</Box>
				</MenuItem>
			})
		}
	</LabeledSelect>

}

export default SelectLlmModel